/**
 * Dismiss any OS-level push notifications that belong to a specific conversation.
 * Called when the user reads the conversation so stale grouped-count state is cleared.
 *
 * Silently no-ops when the browser doesn't support service workers or when the
 * firebase-messaging service worker hasn't been registered yet.
 */
export async function dismissConversationNotifications(conversationId: string): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!conversationId) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration(
      '/firebase-cloud-messaging-push-scope'
    );
    if (!registration) return;

    const tag = `msg-${conversationId}`;
    const notifications = await registration.getNotifications({ tag });
    notifications.forEach((n) => n.close());
  } catch {
    // Silently ignore — dismissing notifications is best-effort
  }
}

/**
 * Dismiss OS notifications by type (e.g. clear all "CAMPAIGN_COMPLETED" after user views campaigns).
 */
export async function dismissNotificationsByType(type: string): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!type) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration(
      '/firebase-cloud-messaging-push-scope'
    );
    if (!registration) return;

    const tag = String(type).toUpperCase();
    const notifications = await registration.getNotifications({ tag });
    notifications.forEach((n) => n.close());
  } catch {
    // Silently ignore
  }
}
